<template>
    <WebCam
        ref="webcam"
        :deviceId="deviceId"
        width="auto"
        height="100%"
        :isFrontCam="frontCam"
        @notSupported="notsupported"
    >
    </WebCam>
</template>
<script>
import { WebCam } from 'vue-cam-vision'

export default {
    data () {
        return {
            captures: [],
            imgReport: [],
            frontCam: true,
            webcam: null,
            img: null,
            camera: null,
            deviceId: null,
            devices: [],
        }
    },
    components: {
        WebCam
    },
    create(){
        this.startCamera();
    },
    methods:{
        startCamera(){
            if(this.$refs.webcam) {
                this.$refs.webcam.start();
            }
        },
        stopCamera(){
            this.$refs.webcam.stop();
        },
        async onCapture () {
            this.img = await this.$refs.webcam.capture();
            this.$emit('photoTaken', this.img);
            return this.img;
        },
        notSupported(){
            this.$emit('notSupported');
        }
    }
}

</script>
